/**
 * Configuração do Html5Qrcode para leitores de atribuição de lote.
 * Várias tentativas: resolução + autofocus contínuo (quando o dispositivo suporta),
 * depois HD sem advanced, depois modo básico.
 */

import { Html5Qrcode } from 'html5-qrcode';

function dynamicQrbox(viewfinderWidth, viewfinderHeight){
	const m = Math.min(viewfinderWidth, viewfinderHeight);
	const n = Math.min(300, Math.max(220, Math.floor(m * 0.68)));
	return { width: n, height: n };
}

const scanBase = {
	fps: 12,
	qrbox: dynamicQrbox,
	aspectRatio: 1,
};

export function getAssignDeliveryScanAttempts(){
	return [
		{
			name: 'hd-continuous-focus',
			scan: {
				...scanBase,
				videoConstraints: {
					facingMode: { ideal: 'environment' },
					width: { ideal: 1920, min: 640 },
					height: { ideal: 1080, min: 480 },
					advanced: [{ focusMode: 'continuous' }],
				},
			},
		},
		{
			name: 'hd',
			scan: {
				...scanBase,
				fps: 12,
				videoConstraints: {
					facingMode: { ideal: 'environment' },
					width: { ideal: 1280, min: 640 },
					height: { ideal: 720, min: 480 },
				},
			},
		},
		{
			name: 'basic',
			cameraArg: { facingMode: 'environment' },
			scan: {
				fps: 10,
				qrbox: { width: 260, height: 260 },
			},
		},
	];
}

/** Inicia a câmera com fallback entre tentativas. Instâncias com falha são paradas/limpadas. */
export async function startAssignDeliveryHtml5Reader(elementId, onDecoded, onScanFrameError){
	const attempts = getAssignDeliveryScanAttempts();
	let lastErr;
	for(let i = 0; i < attempts.length; i++){
		const attempt = attempts[i];
		const html5 = new Html5Qrcode(elementId);
		const cameraArg = attempt.cameraArg || { facingMode: 'environment' };
		try {
			await html5.start(
				cameraArg,
				attempt.scan,
				(decodedText, _result) => onDecoded(decodedText, html5),
				onScanFrameError || (() => {})
			);
			return { html5 };
		}catch(err){
			lastErr = err;
			try {
				await html5.stop();
			}catch(_e){ /* noop */ }
			try {
				html5.clear();
			}catch(_e2){ /* noop */ }
		}
	}
	throw lastErr;
}

export function scrollQrReaderIntoView(elementId){
	window.requestAnimationFrame(() => {
		window.requestAnimationFrame(() => {
			const el = document.getElementById(elementId);
			if(el){
				el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
			}
		});
	});
}
